export default () => ({
  policies: [],
  policy: {},
  claims: [],
  claim: {},
  policiesMeta: {},
  claimsMeta: {},
  claimsHistoriesPolicy: {},
  claimsHistoriesClaim: {},
  partners: [],
  products: [],
  productCategories: [],
  uploadProgress: 0,
});
